await themeResource(theme.resources['mc-shopify'], false);
await themeComponent(theme.components['mc-element'], false);


class McBtn extends McElement {
    
    static TARGET = (source, selector, closest = "") => {
        switch(selector){
            case '__parent__':
                return source.parentElement;
            case '__closest__':
                return source.closest(closest);
            case '__form__':
                return source.closest('form');
            case '__subs__':
                source.multipleTargets = true;
                return source.querySelectorAll('mc-btn');
            case '__multiple__':
                source.multipleTargets = true;
                return document.querySelectorAll(source.dataset.selector);
            case '__next__': 
                return source.nextElementSibling;
            default:
                return document.querySelector(selector);
        }
    }

    static ACTIONS = {
        activate: (source) => {source.target.activate(); if(source.dataset.metoo != undefined){source.activate()}},
        deactivate: (source) => { source.target.deactivate(); if(source.dataset.metoo != undefined){source.deactivate()}},
        toggle: (source) => { 
            if(source.dataset.metoo != undefined){
                source.toggle();
            }
            if(source.multipleTargets){
                source.target.forEach((element) => {
                    element.toggle();
                })
            }
            else{
                source.target.toggle(); 
            }
        },
        addToCart: (source) => {McShopify.addToCart({form: source.target, onComplete: () => {
                axios({
                    url: window.location.href,
                    method: 'get'
                }).then((response) => {
                    document.querySelector('#general-refresher').reload(response.data);
                    if(source.wait && source.next){
                        source.dispatchEvent(new Event(MCEVENTS.READY));
                    }
                })
            }})},
        selectOption: (source) => {
            const request = source.dataset.link;
            axios({
                method: 'get',
                url: request,
            }).then(response => {
                source.target.reload(response.data);
                window.history.replaceState(null, null, request);
            });
        },
        rotateBarrel: (source) => {
            const rotation = 'rotate-' + source.dataset.plank;
            source.target.classList.remove(source.target.dataset.rotation);
            source.target.dataset.rotation = rotation;
            source.target.classList.add(rotation);
            if(source.dataset.metoo != undefined){
                source.activate();
                source.parentElement.querySelectorAll('mc-btn').forEach(btn => {if(btn != source){btn.deactivate()}})
            }
        },
        custom: (source) => {
            const func = new Function(source.dataset.func);
            func(source);
        },
        alias: (source) => {
            source.target.action();
        },
        nop: (source) => 0,

    }
    //We Newton now...
    static REACTIONS = {
        activate: McBtn.ACTIONS.deactivate,
        deactivate: McBtn.ACTIONS.activate,
        toggle: McBtn.ACTIONS.toggle,
        addToCart: (source = null) => 0,
        selectOption: (source = null) => 0,
        rotatebarrel: McBtn.ACTIONS.rotateBarrel,
        custom: McBtn.ACTIONS.nop,
    }
    constructor(){
        super();
    }
    
    action = () => {
        McBtn.ACTIONS[this.dataset.action || 'toggle'](this);
        if(this.wait){
            return;
        }
        this.next ? this.next.dispatchEvent(new Event(MCEVENTS.TRIGGER)) : ()=>0;
    }
    reaction = () => {
        McBtn.REACTIONS[this.dataset.action || 'toggle'](this);
    }

    attemptRegistration = (attempt = 0) => {
        if(attempt >= 10){
            return;
        }
        if(this.target.registerReference == undefined){
            setTimeout(() => {this.attemptRegistration(attempt + 1)});
            return;
        }
        this.target.registerReference(this);
    }

    connectedCallback(){
        this.multipleTargets = false;
        this.ready = false;
        this.target = McBtn.TARGET(this, this.dataset.target, this.dataset.closest ?? "");
        if(this.target && !this.multipleTargets){
            this.attemptRegistration();
        }
        this.addEventListener('click', this.action);
        this.addEventListener(MCEVENTS.TRIGGER, this.action);
        this.next = this.dataset.cascading != undefined ? this.querySelector('mc-btn.next') : null;
        if(this.dataset.delay != undefined){
            this.wait = true;
            this.addEventListener(MCEVENTS.READY, () => {
                this.next.dispatchEvent(new Event(MCEVENTS.TRIGGER));
            })
        }
        else{
            this.wait = false;
        }
        if(this.dataset.autotrigger != undefined){ setTimeout(this.action)};
    }
}

if(!window.customElements.get('mc-btn')){
    window.customElements.define('mc-btn', McBtn);
}
window.McBtn = McBtn;